module.exports = __webpack_public_path__ + "static/media/photo192.b9ff9730.jpg";